import { BrowserRouter, Routes, Route } from "react-router-dom";
import AvatarPage from "./pages/main/star-enterprise";
import Home from "./pages/home/home";
import "./App.scss";
import AvatarPageHospital from "./pages/main/hospital";
import AvatarPageClassroom from "./pages/main/classroom";
import HospitalHome from "./pages/home/hospital-home";
import ClassroomHome from "./pages/home/classroom-home";
import ChromaPage from "./pages/sample/chroma";
import UniversityHome from "./pages/home/university-home";
import AvatarPageUniversity from "./pages/main/university";
import Landing from "./pages/landing/landing";
import DeepseekHome from "./pages/home/deepseek-home";
import DeepseekAvatarPage from "./pages/main/deepseek";

function App() {

  return (
    <BrowserRouter basename="/chatgptaidemo">
      <div className="App">
      {/* <BrowserRouter > */}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/star-enterprise/" element={<Home />} />
        <Route path="/deepseek/" element={<DeepseekHome />} />
        <Route path="/hospital/" element={<HospitalHome />} />
        <Route path="/classroom/" element={<ClassroomHome />} />
        <Route path="/:avatarId" element={<AvatarPage />} />
        <Route path="/deepseek/:avatarId" element={<DeepseekAvatarPage />} />
        <Route path="/star-enterprise/:avatarId" element={<AvatarPage />} />
        <Route path="/hospital/:avatarId" element={<AvatarPageHospital />} />
        <Route path="/classroom/:avatarId" element={<AvatarPageClassroom />} />
        <Route path="/chroma" element={<ChromaPage />} />
        <Route path="/university/" element={<UniversityHome />} />
        <Route path="/university/:avatarId" element={<AvatarPageUniversity />} />
      </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
